import axiosNode from '@/axiosInstanceNode.ts'

// Insights live on the airbnb-be-v2 backend (VITE_API_ENDPOINT_NODE), versioned per-endpoint via the path.
/*insight metrics*/
interface HttpInsightsMetricsOptions {
    params: {start_date: string; end_date?: string}
}
export const httpInsightMetrics = ({params}: HttpInsightsMetricsOptions) =>
    axiosNode.get('/v3/navigate/photographers/insights/metrics', {params})

/*insight common issues*/
interface HttpCommonIssuesOptions {
    params: {start_date: string; end_date?: string}
}

export const httpCommonIssues = ({params}: HttpCommonIssuesOptions) =>
    axiosNode.get('/v3/navigate/photographers/insights/issue', {params})
